import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

// Safely convert description to string (handles Pydantic error arrays and all edge cases)
const safeDescription = (desc) => {
  if (desc === null || desc === undefined) return null;
  
  if (typeof desc === 'string') {
    // Convert Pydantic internal messages to user-friendly text
    if (desc.match(/[Ii]nput should be|[Vv]alue is not a valid|[Ff]ield required|[Ss]tring type/)) {
      return 'Something went wrong processing your request. Please try again.';
    }
    return desc;
  }
  
  // Handle arrays (Pydantic validation errors from FastAPI 422)
  if (Array.isArray(desc)) {
    if (desc.length > 0 && desc[0]?.msg) {
      // This is a Pydantic validation error array — don't show internal details
      return 'Something went wrong processing your request. Please try again.';
    }
    if (desc.length > 0 && typeof desc[0] === 'string') return desc[0];
    return 'An error occurred';
  }
  
  if (typeof desc === 'object') {
    if (desc.msg) {
      if (desc.msg.match(/[Ii]nput should be|[Vv]alue is not a valid/)) {
        return 'Something went wrong processing your request. Please try again.';
      }
      return desc.msg;
    }
    if (desc.detail) return safeDescription(desc.detail);
    if (desc.error) return typeof desc.error === 'string' ? desc.error : 'An error occurred';
    if (desc.message) return typeof desc.message === 'string' ? desc.message : 'An error occurred';
    return 'An error occurred';
  }
  
  try { return String(desc); } catch { return 'An error occurred'; }
};

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        const safeDesc = safeDescription(description);
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {safeDesc && (
                <ToastDescription>{safeDesc}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
